module.exports = __webpack_public_path__ + "img/nomadis.c28b9e28.svg";